export default __webpack_public_path__ + "static/media/HomePage.de8fa255.jpg";